module.exports = __webpack_public_path__ + "media/images/top/icon/green/ico_check-3d3da58378bd902f038da5f92ba4e518.svg";